import { customerRoutes } from 'noddi-util';
import { useIncomingTireSeasonItems, useIsTireHotelPickupRequired } from 'noddi-web';

/** Where the mobile booking flow goes once services and addons are chosen: tire season, tire pickup, then time. */
export const useNextStepAfterServicesPath = () => {
  const isIncomingTireSeasonRequired = useIncomingTireSeasonItems().length > 0;
  const isTireHotelPickupRequired = useIsTireHotelPickupRequired();

  if (isIncomingTireSeasonRequired) {
    return customerRoutes.newBookingTireHotelSeason.getPath();
  }
  if (isTireHotelPickupRequired) {
    return customerRoutes.newBookingTireHotel.getPath();
  }
  return customerRoutes.newBookingTimeWindow.getPath();
};
